/* eslint-disable indent */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-shadow */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/no-array-index-key */
/* eslint-disable react/prop-types */
import colors from 'constants/colors';
import _ from 'lodash';
import React, { useMemo } from 'react';
import { Button, Card, CardBody, CardHeader } from 'reactstrap';
import { Col, Row } from 'antd';
import { isImageUrl } from 'utils/validateValue';
import { getWidthOfString } from 'utils/functionsHtml';
import { prefix } from 'constants/optionCommon';
import QuestionHeader from '../QuestionHeader';

import AudioButton from '../AudioButton';
import './styles.scss';
import QuestionText from '../QuestionText';
import QuestionImage from '../QuestionImage';

export function renderUnderline(item) {
  let flag = false;
  return item?.split('').map((character, index) => {
    if (character === '<') {
      flag = true;
    }
    if (character === '>') {
      flag = false;
    }
    // Nếu là '<' hoặc '>' thì bỏ qua
    if (character === '<' && flag) return '';
    if (character === '>' && !flag) return '';

    // return <React.Fragment key={index}>{flag ? <span style={{ textDecoration: 'underline' }}>{character}</span> : character}</React.Fragment>;
    return <React.Fragment key={index}>{flag ? <span style={{ borderBottom: '3px solid #000' }}>{character}</span> : character}</React.Fragment>;
  });
}

// function getOneChoiceScore(answers, userAnswers) {
//   const count =
//     userAnswers?.filter((userAnswer, index) => {
//       return userAnswer?.isCorrect;
//     })?.length ?? 0;
//   const correctAnswers = answers?.filter((answer) => answer.isCorrect);
//   // Thang điểm 100
//   return count ? Math.floor((count / (correctAnswers?.length || 1)) * 100) : 0;
// }

export const calculateMultipleChoiceScore = (answers, question) => {
  const correctAnswerCountArray = answers?.map((question) => {
    return question.reduce((total, answer) => {
      return total + (answer.isCorrect ? 1 : 0);
    }, 0);
  });
  const questionsCorrectCountArray = question.answers?.map((question) => {
    return question.answers?.reduce((total, answer) => {
      return total + (answer.isCorrect ? 1 : 0);
    }, 0);
  });
  const questionArray = questionsCorrectCountArray.map((count, index) => {
    const answerCount = correctAnswerCountArray[index] || 0;
    return Math.round((answerCount / (count || 1)) * 100);
  });
  return questionArray;
};

function OneChoice({ data, userData, questionIndex = 1, preview = false, showUserData = false, shuffed = false, hiddenTitle = false, isCombine = false }, ref) {
  // const [selectedAnswer, setSelectedAnswer] = React.useState(Array(data.answers.length).fill(null));
  // const [selectedAnswer, setSelectedAnswer] = React.useState(Array(data.answers.length).fill([]));
  const [selectedAnswer, setSelectedAnswer] = React.useState(() => (Array.isArray(data.answers) ? data.answers.map(() => []) : []));

  const showColor = (userData && showUserData) || preview;
  const isAnyQuestion = data.answers && data.answers.length > 1;
  const answersWidthDivId = `width-answer-div-${data?.id}`;
  /** Mảng số câu trả lời đúng của từng câu hỏi con */
  const dataCorrectAnswerCountArray = data.answers.map((item) => {
    return item.answers.filter((answer) => answer.isCorrect).length;
  });
  // const shuffledAnswers = useMemo(() => {
  //   const shuffled = data.answers.map((child) => _.shuffle(child.answers));
  //   return shuffled;
  // }, [data?.id]);

  const shuffledAnswers = useMemo(() => {
    if (preview) {
      // Ở chế độ preview, không xáo trộn, sử dụng thứ tự gốc
      return data.answers.map((child) => child.answers);
    }
    // Ở chế độ khác, xáo trộn đáp án như trước
    return data.answers.map((child) => _.shuffle(child.answers));
  }, [data?.id, preview]);

  const isOneChoice = data?.optionType?.includes('ONECHOICE');

  React.useImperativeHandle(ref, () => ({
    getQuestionResult: async () => {
      const resultArray = calculateMultipleChoiceScore(selectedAnswer, data);
      const result = Math.round(resultArray.reduce((a, b) => a + b, 0) / (resultArray.length || 1));
      return { question: data, userData: { id: data.id, answers: selectedAnswer, result } };
    },
    showResult() {},
    startQuestion() {},
  }));

  // React.useEffect(() => {
  //   //Hiển thị lại kết quả làm bài
  //   if (userData && showUserData) {
  //     setSelectedAnswer(userData.answers);
  //   }
  //   // Chế độ xem trước
  //   // else if (preview) {
  //   //   const correctAnswer = data.answers.map((item, index) => {
  //   //     const indexAnswer = item.answers.findIndex((answer, i) => answer.isCorrect);
  //   //     return indexAnswer >= 0 ? { ...item.answers[indexAnswer], index: indexAnswer } : null;
  //   //   });
  //   //   setSelectedAnswer(correctAnswer);
  //   // }
  //   else if (preview) {
  //     const correctAnswers = data.answers.map((item) => {
  //       return item.answers.filter((answer) => answer.isCorrect); // Lấy tất cả đáp án đúng
  //     });
  //     setSelectedAnswer(correctAnswers);
  //   }
  // }, [data, preview, userData]);

  React.useEffect(() => {
    if (userData && showUserData) {
      setSelectedAnswer(userData.answers.map((ans) => (Array.isArray(ans) ? ans : [])));
    } else if (preview) {
      const correctAnswers = data.answers.map((item) => (Array.isArray(item.answers) ? item.answers.filter((answer) => answer.isCorrect) : []));
      setSelectedAnswer(correctAnswers);
    }
  }, [data, preview, userData]);

  // const onSelectedAnswer = (answer, index) => {
  //   const selected = [...selectedAnswer];
  //   selected[index] = answer;
  //   setSelectedAnswer(selected);
  // };
  // chọn được nhiều đáp án đúng
  const onSelectedAnswer = (answer, parentIndex) => {
    setSelectedAnswer((prev) => {
      // Ensure the array is properly sized to accommodate parentIndex
      const updatedAnswers = [...prev];
      while (updatedAnswers.length <= parentIndex) {
        updatedAnswers.push([]);
      }

      let newAnswers = [...(updatedAnswers[parentIndex] || [])];
      if (isOneChoice || dataCorrectAnswerCountArray[parentIndex] === 1) {
        // Nếu chỉ chọn 1 đáp án
        newAnswers = [answer];
      } else {
        // Nếu chọn nhiều đáp án
        const index = newAnswers.findIndex((a) => a.answer === answer.answer);

        if (index >= 0) {
          // Nếu đáp án đã được chọn, bỏ chọn nó
          newAnswers.splice(index, 1);
        } else if (newAnswers.length < (dataCorrectAnswerCountArray[parentIndex] || 1)) {
          // Số câu trả lời được chọn tối đa bằng số câu hỏi đúng
          // Nếu chưa chọn, thêm vào danh sách
          newAnswers.push(answer);
        }
      }

      updatedAnswers[parentIndex] = newAnswers;
      return updatedAnswers;
    });
  };

  // Render đáp án hình ảnh
  const renderImageAnswers = (answer, index, parentIndex) => {
    // const isSelected = selectedAnswer[parentIndex]?.answer === answer.answer;
    const isSelected = selectedAnswer[parentIndex]?.some((sel) => sel.answer === answer.answer);

    const borderColor = isSelected ? (showColor ? (answer.isCorrect ? colors.green : colors.warning) : colors.dodgerBlue) : showUserData && answer.isCorrect ? colors.green : '#adb5bd';
    return (
      <div
        key={`answer-${parentIndex}-${index}`}
        className='tw-p-4'
        style={{
          cursor: 'pointer',
          borderRadius: 8,
          border: `2px dashed ${borderColor}`,
        }}
        onClick={() => {
          if (!showColor) {
            onSelectedAnswer({ ...answer, index }, parentIndex);
          }
        }}
      >
        {`${prefix[index]}. `}
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          {' '}
          <img alt='' src={answer.answer} style={{ maxHeight: 220 }} />
        </div>
      </div>
    );
  };

  // Dựa theo đáp án để tính toán xem bố cục render các câu trả lời
  const getAnswersColProps = (answers) => {
    const myDiv = document.getElementById(answersWidthDivId);
    const answerWidth = myDiv?.offsetWidth;
    if (isImageUrl(answers?.[0]?.answer ?? '')) {
      if (answerWidth > 576) {
        return { flex: 1 };
      }
      return { span: 12 };
    }

    let minWidth = 0;
    answers.forEach((answer) => {
      const answerWidth = getWidthOfString(answer.answer, '18px');
      minWidth = minWidth + answerWidth + 50; // 50 là 50px cộng thêm cho padding và gutter
    });
    if (answerWidth >= minWidth) {
      return { flex: 1 };
    }
    const average = Math.floor(minWidth / answers.length);
    if (answerWidth >= average * 2) {
      return { span: 12 };
    }
    // Mặc định hiển thị A-B-C-D theo chiều dọc
    return { span: 24 };
  };

  // Render đáp án chữ
  const renderAnswers = (answer, index, parentIndex) => {
    // const isSelected = selectedAnswer[parentIndex]?.answer === answer.answer;
    // const isSelected = selectedAnswer[parentIndex]?.some(sel => sel.answer === answer.answer);

    // fix view bài làm bị trắng màn do không phải mảng
    // const isSelected = Array.isArray(selectedAnswer[parentIndex]) && selectedAnswer[parentIndex].some((sel) => sel.answer === answer.answer);
    const answersArray = selectedAnswer[parentIndex] || []; // Nếu `undefined`, gán thành mảng rỗng
    const isSelected = Array.isArray(answersArray) && answersArray.some((sel) => sel.answer === answer.answer);

    const isCorrectStyle = isSelected
      ? { color: 'white', backgroundColor: !showColor ? colors.dodgerBlue : answer.isCorrect ? colors.green : colors.warning }
      : showUserData && answer.isCorrect
      ? { backgroundColor: colors.green, color: 'white' }
      : {};
    return (
      <Button
        key={`answer-${parentIndex}-${index}`}
        onClick={() => {
          if (!showColor) {
            onSelectedAnswer({ ...answer, index }, parentIndex);
          }
        }}
        style={{ border: '1px solid #bbb9b9', fontSize: 17, width: '100%', ...isCorrectStyle }}
        disabled={showColor}
      >
        {`${prefix[index]}. `}
        {renderUnderline(answer.answer, true)}
      </Button>
    );
  };

  // RENDER Question
  const renderQuestion = () => {
    return data.answers.map((childQuestion, childIndex) => {
      const { question, answers } = childQuestion;
      const colProps = getAnswersColProps(answers);
      return (
        <div key={childIndex}>
          <div className='questionText' style={{ fontSize: 16 }} dangerouslySetInnerHTML={{ __html: question }} />
          <Row gutter={[12, 12]}>
            {shuffledAnswers[childIndex].map((answer, index) => {
              return (
                <Col key={index} {...colProps}>
                  {isImageUrl(answer.answer) ? renderImageAnswers(answer, index, childIndex) : renderAnswers(answer, index, childIndex)}
                </Col>
              );
            })}
          </Row>
        </div>
      );
    });
  };

  return (
    <Card id={`type-onechoice-${data.id}`}>
      {!hiddenTitle && (
        <CardHeader>
          <QuestionHeader title={data.title} subTitle={data.subTitle} questionIndex={questionIndex} />
        </CardHeader>
      )}
      <CardBody>
        <div id={answersWidthDivId} />
        {isAnyQuestion ? (
          <Row gutter={[12, 12]}>
            <Col xs={24} sm={24} lg={12}>
              <div className='question-text-combine' style={{ paddingTop: 20, marginBottom: 20 }}>
                <AudioButton key={questionIndex} audioUrl={data.audioUrl} />
                <QuestionImage key={questionIndex} imageUrl={data.imageUrl} />
                <QuestionText key={questionIndex} questionText={data.questionText} />
              </div>
            </Col>
            <Col xs={24} sm={24} lg={12}>
              <div className='question-component-combine'>{renderQuestion()}</div>
            </Col>
          </Row>
        ) : (
          <div className='question-text-combine' style={{ paddingTop: 20, marginBottom: 20 }}>
            <AudioButton key={questionIndex} audioUrl={data.audioUrl} />
            <QuestionImage key={questionIndex} imageUrl={data.imageUrl} />
            <QuestionText key={questionIndex} questionText={data.questionText} />
            {renderQuestion()}
          </div>
        )}
      </CardBody>
    </Card>
  );
}

export default React.forwardRef(OneChoice);
// ver 1.
